import { useMemo } from "react";
import { useQuery } from "react-query";
import { referenceDataQueryKeys } from "../features/flightSchedule/ScheduleDraft/hooks/queryKeys";
import { scheduleDraftReferenceDataService } from "../features/flightSchedule/ScheduleDraft/services/scheduleDraftReferenceDataService";

const REFERENCE_STALE_TIME = 10 * 60 * 1000;
const REFERENCE_CACHE_TIME = 30 * 60 * 1000;

function getFlightLegKey(leg) {
    const departure = leg.departure_airport || leg.departureAirport || leg.origin;
    const arrival = leg.arrival_airport || leg.arrivalAirport || leg.destination;
    return departure && arrival ? `${departure}-${arrival}` : null;
}

export const useFlightLegs = (options = {}) => {
    const query = useQuery(referenceDataQueryKeys.flightLegs(), () => scheduleDraftReferenceDataService.getFlightLegs(), {
        staleTime: REFERENCE_STALE_TIME,
        cacheTime: REFERENCE_CACHE_TIME,
        refetchOnWindowFocus: false,
        ...options,
    });

    const flightLegs = query.data || [];
    const flightLegMap = useMemo(
        () =>
            flightLegs.reduce((acc, leg) => {
                const key = getFlightLegKey(leg);
                if (key) {
                    acc[key] = leg;
                }
                return acc;
            }, {}),
        [flightLegs],
    );

    return {
        flightLegs,
        flightLegMap,
        isLoading: query.isLoading,
        loading: query.isLoading,
        isFetching: query.isFetching,
        error: query.error,
        refetch: query.refetch,
    };
};

export default useFlightLegs;
